import { Injectable } from '@angular/core';

import { take, tap } from 'rxjs/operators';
import { AppUserCm } from '../data/models';
import { AccountApi } from '../data/services/account-api';
import { NgxPermissionsService } from 'ngx-permissions';
import { KeycloakService } from 'keycloak-angular';
import { uniqBy } from 'lodash-es';
import { getAnyPoolPermissionKey, getPoolPermissionKey } from '../shared/util/auth-util';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  currentUser: AppUserCm;

  constructor(
    private accountApi: AccountApi,
    private ngxPermissions: NgxPermissionsService,
    private keyCloakService: KeycloakService,
  ) {}

  load$() {
    return this.accountApi.getAppUser().pipe(
      take(1),
      tap((u) => {
        this.currentUser = u;
        const tokenRoles = this.keyCloakService.getUserRoles(true);
        const claimRoles = this.currentUser.claims?.map((c) => c.type!);
        const poolClaimRoles = this.currentUser.poolClaims?.map((c) =>
          getPoolPermissionKey(c.poolId, c.type),
        );
        const anyPoolClaimRole =
          uniqBy(this.currentUser.poolClaims, (p) => p.type).map((c) =>
            getAnyPoolPermissionKey(c.type),
          ) ?? [];
        const permissions = tokenRoles
          .concat(claimRoles || [])
          .concat(poolClaimRoles || [])
          .concat(anyPoolClaimRole);
        console.log('started app with roles: ', permissions);
        this.ngxPermissions.loadPermissions(permissions);
      }),
    );
  }

  hasPoolPermission(pool: number, permission: string): boolean {
    return !!this.ngxPermissions.getPermission(getPoolPermissionKey(pool, permission));
  }
}
